/**
 * Add Device Profile Form Schema
 */

import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

// Load form configuration from YAML
const formConfig = FormConfigLoader.loadFormConfig(formYaml)

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

export const NetworkTypeEnum = z.enum(['LoRa', 'WiFi', 'BLE', 'Zigbee', '3G', '4G', '5G'])

// Radio value for "Provisioning Required" — a Yes/No control mapped to a boolean
// in the API payload (see transformToApiRequest).
export const ProvisioningRequiredEnum = z.enum(['yes', 'no'])

export const AddDeviceProfileFormSchema = z.object({
  deviceProfileName: z.string().min(1, 'Profile name is required').max(100),
  deviceProfileNetwork: NetworkTypeEnum,
  provisioningRequired: ProvisioningRequiredEnum.default('yes'),
  region: z.string().optional(),
  macVersion: z.string().optional(),
  supportsOtaa: z.boolean().optional(),
  supportsClassB: z.boolean().optional(),
})

export type AddDeviceProfileFormData = z.infer<typeof AddDeviceProfileFormSchema>

export const transformToApiRequest = (formData: AddDeviceProfileFormData) => {
  const networkType = formData.deviceProfileNetwork
  const attributes = {
    region: formData.region,
    macVersion: formData.macVersion,
    deviceSupportsOtaa: formData.supportsOtaa,
    devicesupportsClassB: formData.supportsClassB,
  }

  // Always send all attribute objects, with empty objects for non-selected types
  return {
    deviceProfileName: formData.deviceProfileName,
    deviceProfileNetwork: networkType,
    // Yes/No radio → boolean; drives whether the Prov service is triggered.
    provisioningRequired: formData.provisioningRequired === 'yes',
    deviceProfileLoraAttributes: networkType === 'LoRa' ? attributes : {},
    deviceProfileWifiAttributes: networkType === 'WiFi' ? attributes : {},
    deviceProfileBleAttributes: networkType === 'BLE' ? attributes : {},
    deviceProfileZigbeeAttributes: networkType === 'Zigbee' ? attributes : {},
  }
}
